import { UseMutationOptions, useMutation } from "@tanstack/react-query"
import { AxiosInstance, AxiosResponse } from "axios"
import { IPropsUpdateTeamMember, IResponseUpdateTeamMember } from "./types"
import { useApi } from "../../useApi"
import { putUpdateTeamMemberURL } from "../../../utils/constants"
import { Dispatch, SetStateAction, useContext } from "react"
import { ToastMessageContext } from "@context/toast-message-cotnext"
import { useTranslation } from "react-i18next"
async function putUpdateTeamMember(
	responseData: IPropsUpdateTeamMember,
	apiPrivate: AxiosInstance,
	showError: Dispatch<SetStateAction<string | undefined>>,
	language: string
): Promise<AxiosResponse<IResponseUpdateTeamMember>> {
	try {
		const response: AxiosResponse<IResponseUpdateTeamMember> =
			await apiPrivate.put(`${putUpdateTeamMemberURL}`, { ...responseData })

		return response
	} catch (error: any) {
		showError(
			error.response?.data?.errorMessages
				.map((item: any) =>
					language === "ar" ? item.messageAr : item.messageEn
				)
				.join(", ")
		)
		return error
	}
}

export function usePutUpdateTeamMember(
	options?:
		| Omit<
				UseMutationOptions<
					AxiosResponse<IResponseUpdateTeamMember>,
					unknown,
					unknown,
					AxiosResponse<IResponseUpdateTeamMember>
				>,
				"mutationFn"
		  >
		| undefined
) {
	const { showError } = useContext(ToastMessageContext)
	const {
		i18n: { language },
	} = useTranslation()
	const { apiPrivate } = useApi()
	const mutation = useMutation({
		mutationFn: (data: IPropsUpdateTeamMember) =>
			putUpdateTeamMember(data, apiPrivate, showError, language),
		...options,
	})
	return mutation
}
